"use strict";

(function () {
    const option = {
        showEditButton: true,
        itemFields: ["DocumentID", "IsShowDownload"],
        addItem(createNewItemCallback) {
            EWS.Document.Select("Image,HTML,PDF,Excel", (document, title, documentType, showDownloadButton) => {
                createNewItemCallback(title, {
                    DocumentID: document,
                    IsShowDownload: showDownloadButton
                });
            });
        },
        editItem(title, itemFields, dashboardItem, editItemCallback) {
            // Task 606021: CRM - Remove 3rd party JS/CSS libraries (including jQuery) from Encompass by 1/1/2020
            ECP.Tools.Ajax(`api?APICommand=Document_GetFileTypeByDocumentID&DocumentID=${itemFields.DocumentID}`, {
                method: "GET"
            }).then((response) => {
                response.json().then((result) => {
                    let isHtml = false;

                    if (result.FileType.toLowerCase() === "html" || result.FileType.toLowerCase() === "htm") {
                        isHtml = true;
                    }

                    // to do: ajax get extension
                    if (isHtml) {
                        EWS.Document.Edit(parseInt(itemFields.DocumentID),
                            (document, docTitle) => {
                                editItemCallback(docTitle,
                                    {
                                        DocumentID: document,
                                        IsShowDownload: "false"
                                    });
                            },
                            title);
                    } else {
                        EWS.Document.Select("Image,HTML,PDF,Excel",
                            (document, docTitle, documentType, showDownloadButton) => {
                                editItemCallback(docTitle,
                                    {
                                        DocumentID: document,
                                        IsShowDownload: showDownloadButton
                                    });
                            },
                            itemFields.DocumentID,
                            title,
                            itemFields.IsShowDownload);
                    }
                });
            });
        },
        createViewButtons(dashboardItem) {
            const buttons = [];

            if ((dashboardItem.getAttribute("item-type") === "PrivateDocument" || dashboardItem.getAttribute("item-type") === "Private Document") && dashboardItem.getAttribute("data-itemfield-isshowdownload") === "true") {
                const documentId = dashboardItem.getAttribute("data-itemfield-documentid");
                if (!EC_Fmt.isNull(documentId)) {
                    buttons.push(EC_Fmt.HtmlStrToElement(`  <a href="api?APICommand=SalesComm_DocumentDownload&DocumentID=${documentId}" class="widget-action item-action ews-icon-download" Title="Download"></a>`));
                }
            }

            const downloadIcon = dashboardItem.querySelector(".ews-icon-download");

            if (downloadIcon) {
                downloadIcon.parentElement.removeChild(downloadIcon);
            }

            return buttons;
        }
    };

    EWS.DashboardItemTypesManager.add("PrivateDocument", option);
    EWS.DashboardItemTypesManager.add("Private Document", option);
}());
